<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";
  
  export let block;
</script>

<header>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="/" use:link>
        <img src="{image(block, 'logo', [null, 100])}" height="50" alt="Demo">
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0">
          {#each blocklist(block, 'menu') as item}
          <li class="nav-item">
            <a class="nav-link" href="{url(item, 'link')}" use:link>{text(item, 'link')}</a>
          </li>
          {/each}
        </ul>
      </div>
    </div>
  </nav>
</header>
